/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {recordPayerTaggingPromptDismissal} from '../api'

export const useMutationRecordPayerTaggingPromptDismissal = createReactQueryMutationHook('recordPayerTaggingPromptDismissal', recordPayerTaggingPromptDismissal)
